import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class MvmNaviresService {

  constructor(private http:HttpClient, private global:Global) { }

    httpOptions = {
      headers: new HttpHeaders({
        "accept": "application/json;odata=Nometadata",
        "content-type": "application/json;odata=verbose"
      })
    };

    getMvmNaviresAutorisee(){
      return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/mvmnv/autorisee",this.httpOptions);
    }

  getMvmNaviresGlobal(){
    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/mvmnv/all",this.httpOptions);
  }
  getPreavisByNbr(a){

    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/getPreavisParNumeroConteneur/"+a,this.httpOptions);

  }
  getPreavisByNbrall(a){
    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/getPreavisParNumeroConteneurAll/"+a,this.httpOptions);
  }
  getRdvByNbrC(a){
    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/getRdvsParNumeroConteneur/"+a,this.httpOptions);
  }
  getRdvByNbrR(a){
    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/getRdvsParNumeroRdv/"+a,this.httpOptions);
  }
  getGestionAccessPortSOA(a){
    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/accessport/"+a,this.httpOptions);
  }
  getDocbyCIN(a){
    return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/urldoc/"+a,this.httpOptions);
  }
}
